import styled from 'styled-components';

import {InfoDropdownOverlay as BaseInfoDropdownOverlay} from '@edna/components';
import {Icon} from '@edna/components/primitives';

export const InfoDropdownOverlay = styled(BaseInfoDropdownOverlay)`
  width: max-content;
  border-radius: ${({theme}) => theme.borderRadius.br1};

  & > div {
    padding: ${({theme}) => theme.spacing.s2} 10px;
  }
`;

export const HoveredIcon = styled(Icon)`
  cursor: pointer;
`;
